// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1KFz7","name":"ConsentHeader_name__2b1fa","birthday":"ConsentHeader_birthday__2kc0W","skeleton":"ConsentHeader_skeleton__293Uq"};